import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'

import 'typeface-noto-sans'
import 'react-quill/dist/quill.snow.css'
import './index.css'

import { App } from './App'
import { AppProviders } from './providers'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <StrictMode>
    <HelmetProvider>
      <AppProviders>
        <App />
      </AppProviders>
    </HelmetProvider>
  </StrictMode>,
)
